export default __webpack_public_path__ + "static/4-6c6098463fa0a12fbd37086ac49b37a7.jpg";